import { generatePath } from 'react-router';
import { projectColors } from './constants';

export const extractInitials = (projectName) => {
  if (typeof projectName !== 'string' || projectName === '') {
    return '';
  }
  const words = projectName.trim().split(/\s+/g);
  const initials = words.map((word) => word[0].toUpperCase());

  let result = '';

  if (initials.length === 1) {
    [result] = initials;
  }
  if (initials.length > 1) {
    result = initials[0] + initials[initials.length - 1];
  }
  return result;
};

export const generateUrl = (projectId, urlParams) => {
  const path = generatePath('/projects/:projectId', {
    projectId
  });

  return path + urlParams;
};

export const projectColorPicker = (numberOfProjects) => {
  const colors = [];

  while (colors.length < numberOfProjects) {
    colors.push(...projectColors);
  }
  return colors;
};
